module.exports = __webpack_public_path__ + "static/media/facebook-footer.423ca15c.svg";